import { combineReducers } from '@reduxjs/toolkit';
import { titleReportReducer } from './titleInformation/reducer';
import { orderCancellationRequestStateReducer } from './orderCancellationRequest';
import { cdBuilderReducer } from './cdBuilder';
import { discountsReducer } from './discounts';
import { PayoffRequestsReducer } from './payoffRequests/reducer';
import { titleSearchRequestsReducer } from './titleSearchRequests/reducer';
import { finalizePoliciesSlice } from './policy/finalizePoliciesSlice';
import { partiesActionsSlice } from './orderData/partiesActionsSlice';
import { taxCertification } from './taxCertifications/store';
import { orderNavigationSlice } from './orderNavigation/orderNavigationSlice';
import { activitySlice } from './activity/activitySlice';
import { activityActionsSlice } from './activity/activityActionsSlice';
import { activityUsersSlice } from './activity/activityUsersSlice';
import { resetOrderSlice } from './resetOrder/resetOrderSlice';
import { orderInformationSlice } from './orderInformation/orderInformationSlice';
import { currentOrderSlice } from './currentOrder/currentOrderSlice';
import { documentsReducer } from './documents/documentsReducer';
import { orderHoaReducer } from './orderHoa/OrderHoaReducer';
import { orderEscrowStore } from './escrow/orderEscrowStore';
import { quickFormsSlice } from './quickForms/quickFormsSlice';

export const orderReducer = combineReducers({
  activitySlice: activitySlice.reducer,
  activityActionsSlice: activityActionsSlice.reducer,
  activityUsersSlice: activityUsersSlice.reducer,
  cdBuilder: cdBuilderReducer.reducer,
  currentOrderSlice: currentOrderSlice.reducer,
  discounts: discountsReducer.reducer,
  orderCancellationRequest: orderCancellationRequestStateReducer.reducer,
  orderInformationSlice: orderInformationSlice.reducer,
  payoffRequests: PayoffRequestsReducer.reducer,
  taxCertification: taxCertification,
  titleReport: titleReportReducer.reducer,
  titleSearchRequests: titleSearchRequestsReducer.reducer,
  partiesActionsSlice: partiesActionsSlice.reducer,
  resetOrderSlice: resetOrderSlice.reducer,
  orderNavigationSlice: orderNavigationSlice.reducer,
  uploadPolicies: finalizePoliciesSlice.reducer,
  documents: documentsReducer,
  hoa: orderHoaReducer,
  escrow: orderEscrowStore,
  quickFormsSlice: quickFormsSlice.reducer,
});
